export class Route_eCMRPlatesDto {
	public plateA: string;
	public plateB: string;
	public plateC: string;
	public reset: boolean;

	public static buildReset(): Route_eCMRPlatesDto {
		let result: Route_eCMRPlatesDto = new Route_eCMRPlatesDto();
		result.reset = true;
		return result;
	}

	public static build(plateA: string, plateB: string, plateC: string): Route_eCMRPlatesDto {
		let result: Route_eCMRPlatesDto = new Route_eCMRPlatesDto();
		result.plateA = plateA;
		result.plateB = plateB;
		result.plateC = plateC;
		return result;
	}
}
